import { render, staticRenderFns } from "./fccCorrecaoControle.vue?vue&type=template&id=6a2118bb"
import script from "./fccCorrecaoControle.vue?vue&type=script&lang=js"
export * from "./fccCorrecaoControle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports